import * as React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Destinations from "../components/destinations";
import Video from "../components/video";
import Banner from "../components/banner";
import Slideshow from "../components/slideshow";
import ImageWithText from "../components/image-with-text";
import HomeHero from "../components/home-hero";
import Concept from "../components/concept";

const IndexPage = ({ data }) => {
  const { home } = data;

  return (
    <Layout whiteHeader>
      <Seo home />
      <HomeHero
        title={home.title}
        subtitle={home.subtitle}
        intro={home.intro?.intro}
        heroMedia={home.heroMedia}
        heroMediaMobile={home.heroMediaMobile}
        buttonLink={home.bannerButton}
        hideSubtitle={home.hideSubtitle}
        hideIntroduction={home.hideIntroduction}
      />
      <Concept
        title={home.concept.title}
        description={home.concept.description}
        pictos={home.concept.pictos}
      />
      <Banner
        heading={home.banner?.heading}
        text={home.banner?.text}
        link={home.banner?.link}
        linkText={home.banner?.linkText}
        active={home.banner?.active}
        buttonLink={home.banner?.buttonLink}
      />
      <Destinations
        heading={home.destinationsBlocTitle}
        intro={home.destinationsBlocText}
        buttonLink={home.destinationsBlocButton}
        productsSlider={home.blocDestinationsProducts}
      />
      <Slideshow
        slides={home.quotations}
        quotations={true}
        title={home.quotationsTitle?.quotationsTitle}
        pictures={data.translations.ratingsImages}
        heading
      />
      <Banner
        heading={home.blogBlockTitle.blogBlockTitle}
        buttonLink={home.blogBlockButton}
        active
        large
      />
      {home.video?.isVideoActive && (
        <Video
          video={home.video}
          intro={home.videoBlockTitle}
          buttonLink={home.videoBlockButton}
        />
      )}
      <ImageWithText
        image={home.seoSection?.image}
        mobileImage={home.seoSection?.mobileImage}
        imageAlt={home.seoSection?.imageAlt}
        text={home.seoSection?.text}
        link={home.seoSection?.link}
        modal={home.seoSection?.modal}
        className="full-width"
      />
    </Layout>
  );
};

export default IndexPage;

export const query = graphql`
  query ($locale: String!) {
    home: contentfulHome(
      node_locale: { eq: $locale }
      contentful_id: { eq: "62rvf78k5yrgR3aq2foZ58" }
    ) {
      title
      subtitle
      hideSubtitle
      intro {
        intro
      }
      hideIntroduction
      bannerButton {
        button
        buttonBackgroundColour
        textColour
        title
        link
        target
        modal {
          ...Modal
        }
      }
      banner {
        heading
        text {
          raw
        }
        link
        linkText
        active
        buttonLink {
          button
          buttonBackgroundColour
          textColour
          title
          link
          target
          modal {
            ...Modal
          }
        }
      }
      concept {
        title
        description {
          raw
        }
        pictos {
          image {
            description
            title
            gatsbyImageData
          }
          text {
            raw
          }
        }
      }
      heroMedia {
        title
        file {
          url
          contentType
        }
        description
        gatsbyImageData(quality: 80)
      }
      heroMediaMobile {
        title
        file {
          url
          contentType
        }
        description
        gatsbyImageData(quality: 80)
      }
      video {
        intro {
          raw
        }
        url
        isVideoActive
      }
      quotationsTitle {
        quotationsTitle
      }
      quotations {
        contentful_id
        image {
          description
          title
          gatsbyImageData(quality: 80)
        }
        mobileImage {
          gatsbyImageData(quality: 80)
        }
        imageAlt
        text {
          raw
        }
        link
      }
      blocDestinationsProducts {
        id
        contentful_id
        subtitleCarousel
        referenceProduit
        stayReference
        destination {
          title
          slug
          products: product {
            contentful_id
          }
        }
        featuredImage {
          description
          gatsbyImageData(layout: FULL_WIDTH)
          title
        }
        duration
        badges {
          label
          backgroundColor
          opacity
          textColor
        }
      }
      seoSection {
        image {
          description
          title
          gatsbyImageData(quality: 80)
        }
        mobileImage {
          gatsbyImageData(quality: 80)
        }
        imageAlt
        text {
          raw
        }
        link
        modal {
          ...Modal
        }
      }
      blogBlockButton {
        button
        buttonBackgroundColour
        link
        target
        textColour
        title
        modal {
          ...Modal
        }
      }
      blogBlockTitle {
        blogBlockTitle
      }
      destinationsBlocButton {
        button
        buttonBackgroundColour
        link
        target
        textColour
        title
        modal {
          ...Modal
        }
      }
      destinationsBlocText {
        raw
      }
      destinationsBlocTitle
      videoBlockButton {
        button
        buttonBackgroundColour
        link
        target
        textColour
        title
        modal {
          ...Modal
        }
      }
      videoBlockTitle
    }

    translations: contentfulTranslations(node_locale: { eq: $locale }) {
      translations {
        key
        value
      }
      modalLevels {
        raw
      }
      ratingsImages {
        title
        description
        gatsbyImageData(
          width: 300
          height: 300
          quality: 80
          resizingBehavior: SCALE
        )
      }
    }
  }
`;
